import React, { useState, useRef, forwardRef } from 'react';
import { AutoComplete, Input, icons } from 'daymap-library';
import { useAuth } from '../../helpers/authContext';

const StudentSearch = forwardRef(function ({ onChange, hint, icon, loadingText, noMatchText, placeholder, requiredLength = 3 }, ref) {
    const { lmsFetch } = useAuth();
    const [students, setStudents] = useState(null);
    const [selectedStudent, setSelectedStudent] = useState(null);
    const { settings } = useAuth();

    const searchResults = students && students.map(s => {
        var extraText = ``;

        if (settings.ShowStudentCode)
            extraText = ` (${s.Code}`;

        if (settings.ShowYear && s.Year)
            extraText += !extraText ? ` (Year ${s.Year}` : `, Year ${s.Year}`;

        if (settings.ShowSwipeCardCode && s.SwipeCardCode) {
            extraText += !extraText ? ` (${s.SwipeCardCode}` : `, ${s.SwipeCardCode}`;
        }

        if (extraText)
            extraText += `)`;

        return { text: `${s.Surname} ${s.Displayname}` + extraText, value: s.Code }
    })

    const onTextChanged = txt => {
        onChange && onChange(txt);
        if (txt.length < Math.max(3, requiredLength ?? 3))
            setStudents(null);
        else
            doSearch(txt);
    }

    const setStudent = s => {
        setSelectedStudent(s);
        onChange && onChange(s ? s.value : s);
    }

    const doSearch = async txt => {
        if (!txt) return;

        const [ex, cancel] = lmsFetch('/lms/api/checkin/searchstudentnames?input=' + encodeURI(txt));
        const response = await ex();

        if (response.error)
            setStudents(null);
        else
            setStudents(response.data);
    }

    return (
        <AutoComplete
            iconClass={icon ?? icons.ICON_CSS_CLASS.Search}
            ref={ref}
            loadingText={loadingText}
            noResultsText={noMatchText}
            nothingEnteredText={hint ?? `Type at least ${Math.max(3, requiredLength ?? 3)} characters`}
            placeholder={placeholder ?? "Search Student"}
            onTextChanged={onTextChanged} onChange={setStudent} results={searchResults} value={selectedStudent} />
    )
});

export default StudentSearch;